import { render, staticRenderFns } from "./UserAccountProfileAccounts.vue?vue&type=template&id=2464ba40&"
import script from "./UserAccountProfileAccounts.vue?vue&type=script&lang=js&"
export * from "./UserAccountProfileAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports